import { throttle } from 'lodash';
import { useEffect, useState } from 'react';
/**
 * 与 tci-ui 组件库的移动端判定方式保持一致
 * config-solution 建议都用这个
 */ export var useIsMobileState = function() {
    var ref = useState(false), isMobile = ref[0], setIsMobile = ref[1];
    var checkChange = throttle(function() {
        var winWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
        if (winWidth <= 768) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, 50);
    useEffect(function() {
        checkChange();
        window.addEventListener('resize', checkChange);
        return function() {
            window.removeEventListener('resize', checkChange);
        };
    }, []);
    return [
        isMobile,
        setIsMobile
    ];
};
